import { useState, useEffect } from "react";
import stringHelpers from "../../utilities/stringHelpers";
import { Link, useLocation } from 'react-router-dom';
import Pagination from "../shared/pagination";
import Api from '../api/api';
import roleUtilities from "../../utilities/roleUtilities";
import { ColumnSortTrigger } from "../shared/columnSortTrigger";
import arrayUtilities from "../../utilities/arrayUtilities";
import { toDateTimeString, isDateTimeElapsed } from "../../utilities/dateUtilities";
import { ToggleWithLocalisedLoading } from "../shared/toggleWithLocalisedLoading";
import Loader from "../shared/loader";
import { disallowedVrmEnableDisable } from "../../utilities/allowListUtilities";

export const SiteDisallowList = ({ siteId, site, user, loading, setLoading, organisationId, token, search, start, end, filterPeriodType, siteName, handleCheckChange, multiDeleteList, sites, setErrorMessage }) => {
    const location = useLocation();

    const [buttonId, setButtonId] = useState("");
    const [listId, setListId] = useState("");
    const [disallowList, setDisallowList] = useState(null);
    const [count, setCount] = useState(null);
    const [currentSortBy, setCurrentSortBy] = useState(stringHelpers.sortPreference(`${ user.id }-disallowListSortPreference`).sortBy);

    const [pageNumber, setPageNumber] = useState(0);
    const getDisallowList = function (searchQuery, from, to, page, filterPeriodType, sortBy, sortDirection) {
        setLoading(true)
        Api.searchDisallowedVrms(
            (data) => {
                if (data !== null) {
                    setDisallowList(data.items);
                    setCount(data.totalCount);
                }
                setLoading(false);
            },
            (error) => {
                console.log(error);
                setLoading(false)
            },
            0,
            page,
            searchQuery,
            null,
            from,
            to,
            null,
            siteId,
            filterPeriodType,
            sortBy,
            sortDirection,
            null,
            organisationId,
            token,
            false,
        )
    };

    const changePageNumber = function (num) {
        setPageNumber(num);
        const sortPreference = stringHelpers.sortPreference(`${ user.id }-disallowListSortPreference`);
        getDisallowList(search, start, end, num, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection);
    };

    useEffect(() => {
        if (site && !stringHelpers.isNullOrEmpty(siteId)) {
            const sortPreference = stringHelpers.sortPreference(`${ user.id }-disallowListSortPreference`);
            getDisallowList("", null, null, 0, 0, sortPreference.sortBy, sortPreference.sortDirection);
            setButtonId("#button-" + siteId);
            setListId("#list-" + siteId);
        }
    }, [site])

    useEffect(() => {
        const sortPreference = stringHelpers.sortPreference(`${ user.id }-disallowListSortPreference`);
        getDisallowList(search, start, end, 0, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection);
        setPageNumber(0);
    }, [search, start, end, filterPeriodType]);

    const handleSortTriggerClick = (sortBy, sortDirection) => {
        getDisallowList(search, start, end, pageNumber, filterPeriodType, sortBy, sortDirection);
        if (currentSortBy !== sortBy) {
            setCurrentSortBy(sortBy)
        }
    }

    return (
        <>
            <div className="table-row">
                <button className={ `table-item button-no-style text-left py-3 ${ sites.length > 1 ? "collapsed" : "" }` } id={ buttonId.substring(1) } type="button" data-toggle="collapse" data-target={ listId } aria-expanded="true" aria-controls={ buttonId.substring(1) }>{ siteName } <i className="fas fa-chevron-down"></i></button>
            </div>
            <div className={ `collapse ${ sites.length === 1 ? "show" : "" }` } id={ listId.substring(1) } aria-labelledby="Disallow List" data-parent={ buttonId }>
                <div className="card-body bg-light border-top details-container p-0" >
                    <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer allow-list-table">
                        <thead className="bg-200 text-900">
                            <tr>
                                <th>&nbsp;</th>
                                <th>
                                    <ColumnSortTrigger
                                        onClick={ direction => handleSortTriggerClick(0, direction) }
                                        currentSortBy={ currentSortBy }
                                        sortBy={ 0 }
                                        localStorageKey={ `${ user.id }-disallowListSortPreference` }
                                        label="VRM"
                                    />
                                </th>
                                <th>Driver Name</th>
                                <th>Vehicle</th>
                                <th>Site(s)</th>
                                <th>
                                    <ColumnSortTrigger
                                        onClick={ direction => handleSortTriggerClick(1, direction) }
                                        currentSortBy={ currentSortBy }
                                        sortBy={ 1 }
                                        localStorageKey={ `${ user.id }-disallowListSortPreference` }
                                        label="Start Date"
                                    />
                                </th>
                                <th>End Date</th>
                                <th>
                                    <ColumnSortTrigger
                                        onClick={ direction => handleSortTriggerClick(3, direction) }
                                        currentSortBy={ currentSortBy }
                                        sortBy={ 3 }
                                        localStorageKey={ `${ user.id }-disallowListSortPreference` }
                                        label="Created Date"
                                    />
                                </th>
                                <th>Created By</th>
                                <th className='text-center'>Enabled</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                loading
                                    ? <tr><td colSpan={ 12 }><Loader /></td></tr>
                                    : <>
                                        {
                                            !arrayUtilities.isNullOrEmpty(disallowList) && disallowList
                                                .map((item, i) => <tr key={ item.id } className='fs--2'>
                                                    <td>
                                                        { (
                                                            roleUtilities.isOrganisationAdminOrManager(user, organisationId) ||
                                                            roleUtilities.isClientManager(user, organisationId) ||
                                                            (
                                                                roleUtilities.isClient(user, organisationId) &&
                                                                !stringHelpers.isNullOrEmpty(item.endDate) && isDateTimeElapsed(item.endDate)
                                                            )
                                                        ) && <input
                                                                onChange={ e => handleCheckChange(e.target.value) }
                                                                value={ item.id }
                                                                type="checkbox"
                                                                id={ item.id }
                                                                name={ item.vrm }
                                                            /> }
                                                    </td>
                                                    <td><Link to={ { pathname: `/organisation/${ organisationId }/disallowed-vrm/${ item.id }`, state: { returnUrl: location.pathname } } } className="number-plate-link"><h6 className="mb-0 compact-number-plate">{ item.vrm }</h6></Link></td>
                                                    <td>{ item.driverName }</td>
                                                    <td><div className='allow-list-clamped-cell'>{ item.vehicleMake } { item.vehicleModel }</div></td>
                                                    <td>
                                                        {
                                                            !stringHelpers.isNullOrEmpty(item.siteName)
                                                                ? <>{ item.siteName }</>
                                                                : !stringHelpers.isNullOrEmpty(item.clientName) ? <>{ item.clientName }</> : <>All</>
                                                        }
                                                    </td>
                                                    <td>
                                                        {
                                                            !stringHelpers.isNullOrEmpty(item.startDate)
                                                                ? <>{ toDateTimeString(item.startDate) } </>
                                                                : <span>&mdash; </span>
                                                        }
                                                    </td>
                                                    <td>
                                                        {
                                                            !stringHelpers.isNullOrEmpty(item.endDate)
                                                                ? <> { toDateTimeString(item.endDate) } <span className='text-end'>{ isDateTimeElapsed(item.endDate) && <i className="fas fa-exclamation-triangle text-warning ml-2 fs-1"></i> }</span></>
                                                                : <span>&mdash; </span>
                                                        }
                                                    </td>
                                                    <td>{ !stringHelpers.isNullOrEmpty(item.createdTimestamp) && toDateTimeString(item.createdTimestamp) }</td>
                                                    <td>{ item.createdByUserName }</td>
                                                    <td className='text-center'>
                                                        {
                                                            roleUtilities.isOrganisationProcessor(user, organisationId)
                                                                ? <>
                                                                    { item.isEnabled ? <i className="fas fa-check text-success"></i> : <i className="fas fa-times text-danger"></i> }
                                                                </>
                                                                : <ToggleWithLocalisedLoading
                                                                    checked={ item.isEnabled }
                                                                    id={ `${ item.id }-enable-disable-allowed-vrm` }
                                                                    onChange={ isChecked => disallowedVrmEnableDisable(item.id, isChecked, setErrorMessage, setDisallowList, organisationId, token) }
                                                                    loadingStateTracker={ item }
                                                                />
                                                        }
                                                    </td>
                                                </tr>) }
                                    </>
                            }
                        </tbody>
                    </table>
                </div>
                { !loading && count !== null && <div className="pt-3 border-top ">
                    <div className="d-flex justify-content-center row align-items-center">
                        <div className="col-auto align-items-center">
                            <Pagination totalResults={ count } currentPage={ pageNumber } changePageNumber={ changePageNumber } />
                        </div>
                    </div>
                </div> }
            </div>
        </>
    )
}